import React from 'react';
import { Link } from 'react-router-dom';

const LOGO = '/assets/images/SeedDrive_Black_-1772706977187.png';

export default function LandingFooter() {
  return (
    <footer className="border-t" style={{ borderColor: '#e0e0e0', background: '#ECEAE4' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          {/* Brand */}
          <div className="max-w-xs">
            <Link to="/home-landing-page" className="flex items-center mb-4">
              <img
                src={LOGO}
                alt="SeedDrive logo"
                style={{ height: '30px', width: 'auto' }}
                className="object-contain"
              />
            </Link>
            <p className="text-sm font-body leading-relaxed" style={{ color: '#6b7b7b' }}>
              Infrastructure equity workflow and regulated digital rails for institutional investors.
            </p>
          </div>

          {/* Nav links */}
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { label: 'Home', path: '/home-landing-page' },
              { label: 'Platform', path: '/platform-overview-page' },
              { label: 'How it works', path: '/how-it-works-page' },
              { label: 'Security', path: '/security-compliance-page' },
              { label: 'About', path: '/about-page' },
              { label: 'Contact', path: '/contact-page' },
            ]?.map((link) => (
              <Link
                key={link?.path}
                to={link?.path}
                className="text-sm font-caption transition-colors"
                style={{ color: '#6b7b7b' }}
              >
                {link?.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3" style={{ borderColor: '#e0e0e0' }}>
          <p className="text-xs font-caption" style={{ color: '#9aacac' }}>
            &copy; {new Date()?.getFullYear()} SeedDrive Ltd. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs font-caption transition-colors" style={{ color: '#9aacac' }}>Privacy Policy</a>
            <a href="#" className="text-xs font-caption transition-colors" style={{ color: '#9aacac' }}>Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
